export default {
  currentUserInfo (state) {
    return state.currentUserInfo;
  },

  isLogin (state) {
    return state.currentUserInfo && state.currentUserInfo.loginUserId;
  },
};
